import React, { FC } from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppSettings } from 'context/app-settings';
import { formatDate } from 'utils/format';

/** Names the data set staging runs on. Never shown in production (no activeDbMode there). */
const TestDataBanner: FC = () => {
    const { t: translate } = useTranslation();
    const { appSettings } = useAppSettings();

    if (appSettings.activeDbMode === 'test') {
        return (
            <Alert severity="warning" sx={{ mb: 2 }}>
                <AlertTitle>{translate('common:DATA_SET_BANNER_REGRESSION_TITLE')}</AlertTitle>
                {translate('common:DATA_SET_BANNER_REGRESSION_MESSAGE')}
            </Alert>
        );
    }

    if (appSettings.activeDbMode === 'prodCopy') {
        return (
            <Alert severity="warning" sx={{ mb: 2 }}>
                <AlertTitle>
                    {translate('common:DATA_SET_BANNER_PRODUCTION_COPY_TITLE', {
                        date: formatDate(appSettings.activeDataSetSnapshotDate, 'date') || '?',
                    })}
                </AlertTitle>
                {translate('common:DATA_SET_BANNER_PRODUCTION_COPY_MESSAGE')}
            </Alert>
        );
    }

    return null;
};

export default TestDataBanner;
